module.exports = __webpack_public_path__ + "img/1_1-orto-0.fdb76e11.png";